'use client';

import { useState } from 'react';
import { useSearchParams } from 'next/navigation';

// Components
import { Button, Typography } from '@shared/ui';

// Icons
import GoogleIcon from '@shared/icons/GoogleIcon';

// Constants
import { HERO_CONTENT, QUERY_KEY, ROUTES } from '@shared/constants';
import { COOKIE_KEYS } from '@/constants';

// Utils
import { combineClasses, cookieStorage } from '@shared/utils';
import { showErrorToast } from '@/utils/errorHandlers';

// Providers
import { useFirebase } from '@/providers/firebase';

// Services
import { auth } from '@/services/firebase';
export const HeroSection = () => {
  const {
    signIn
  } = useFirebase();
  const searchParams = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const handleSignInGoogle = async () => {
    try {
      setIsLoading(true);

      // Get intended URL from cookie (set by middleware)
      const cookieIntendedUrl = cookieStorage.getItem(COOKIE_KEYS.INTENDED_URL);
      const decodedIntendedUrl = cookieIntendedUrl ? decodeURIComponent(cookieIntendedUrl) : '';

      // Determine redirect URL: cookie > query param > home
      const returnUrl = decodedIntendedUrl || searchParams.get(QUERY_KEY.RETURN_URL) || ROUTES.HOME;

      // Check if middleware redirect occurred
      const hasMiddlewareRedirect = !!cookieIntendedUrl && returnUrl !== ROUTES.HOME;
      await signIn(returnUrl, hasMiddlewareRedirect);

      // Clear the intended URL cookie AFTER successful sign-in
      if (cookieIntendedUrl) {
        cookieStorage.removeItem(COOKIE_KEYS.INTENDED_URL);
      }

      // If sign-in failed (e.g. invalid email), auth.currentUser is null
      // Reset loading so user can retry. If successful, keep loading
      // until redirect completes.
      if (!auth.currentUser) {
        setIsLoading(false);
      }
    } catch (error: unknown) {
      setIsLoading(false);
      showErrorToast(error);
    }
  };
  return <div className="flex flex-col h-full w-full" data-sentry-component="HeroSection" data-sentry-source-file="Hero.tsx">
      <div className="flex-1 flex flex-col items-center justify-center">
        <div className="flex w-full max-w-hero-section flex-col gap-2 mx-auto items-center">
          <Typography as="p" className="tracking-[12px] font-light text-white text-center login-title-bounce leading-lg" size="5xl" data-sentry-element="Typography" data-sentry-source-file="Hero.tsx">
            {HERO_CONTENT.title}
          </Typography>
        </div>
      </div>

      <div className="w-full mx-auto flex justify-center px-4 pb-12 md:pb-16">
        <Button aria-label="Sign in with Google" className={combineClasses('hero-button-pop', 'flex-center md:max-w-btn-hero rounded-md bg-secondary text-secondary-foreground hover:bg-secondary-100', 'flex-center gap-2 h-10 px-[18px] whitespace-nowrap rounded-md text-3xs font-semibold transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0', 'gap-4 py-0 h-auto min-h-btn', 'font-normal leading-md bg-white text-black hover:bg-white', 'disabled:cursor-not-allowed disabled:opacity-90', 'w-full')} isLoading={isLoading} onClick={handleSignInGoogle} disabled={isLoading} data-sentry-element="Button" data-sentry-source-file="Hero.tsx">
          <GoogleIcon data-sentry-element="GoogleIcon" data-sentry-source-file="Hero.tsx" />
          <span className="hero-button-text">Sign in with Google</span>
        </Button>
      </div>
    </div>;
};